<template>
  <div id="products" class="animated fadeIn pb4">
    <!-- desktop view -->
    <div>
      <WebshopHeader>
      </WebshopHeader>
      <!-- This will render if image doesnt exist -->
      <img class="hide" rel="preload" :src="'https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/streamerPng.php?id='+haaId" v-if="renderedStreamer">
      <img class="hide" rel="preload" :src="'https://widget.haandvaerker.dk/prisen/winnersBadge/bladder/bladderPng.php?id='+haaId" v-if="renderedBladder">
      <!-- <div class="clearfix" v-if="loading">
        <div class="col-12">
          <div class="loader"></div>
          <p class="center mediumgrey bold">Genererer forhåndsvisning...</p>
        </div>
      </div> -->
      <div class="py4 px3" >
        <div>
          <div class="p0">
            <div id="productFilter">
              <el-tabs v-model="activeTabName" :tab-position="tabPosition" @tab-click="tabChanged()">
                <b-form ref="form" :model="form" class="lg-col-6 ml-auto mr-auto">
                  <div class="p0">
                    <b-form-input placeholder="Søg produkt" v-model="search" class="search" clearable>
                    </b-form-input>
                  </div>
                </b-form>
                <div class="pb2"></div>
                <el-tab-pane name="0" class="" :label="'Alle (' + (totalProdCount - deductBadgesProduct) + ')'">
                  <div class="fit">
                    <div class="right-align hide" v-if="prodMsg == ''">
                      <el-pagination small layout="prev, pager, next" :total="parseInt(lastPage)"
                        @current-change="paginationChanged" :current-page="parseInt(curPage)">
                      </el-pagination>
                    </div>
                    <div class="clearfix" v-if="insideLoading">
                      <div class="col-12">
                        <div class="loader"></div>
                        <p class="center mediumgrey bold">Genererer forhåndsvisning...</p>
                      </div>
                    </div>
                    <div class="flex flex-wrap" v-else>
                      <div :id="'prodId-'+prod.ID" class="lg-col-3 md-col-4 p0" v-for="(prod,index) in prodData" :key="index">
                        <div id="imageloading" class="py2 px1">
                          <div class="relative">
                            <div :class="'clearfix py4 img-loader loader-'+prod.ID">
                              <div class="col-12">
                                <div class="loader"></div>
                              </div>
                            </div>
                            <div :class="'hide prodImg-'+prod.ID">
                              <div class="relative border muted-border more-muted-background">
                                <div class="absolute right-0 mt1">
                                  <!-- Bladders download icon -->
                                  <!-- <a class="pointer z2 mt1 download-icon" title="Hent" v-if="prod.PRODUCT_GROUP == '9001'" @click="downloadFiles('https://widget.haandvaerker.dk/prisen/winnersBadge/bladder/rendered/' + haaId + '/badges.zip')">
                                    <i class="el-icon-download darkblue h2"></i>
                                  </a> -->
                                  <!-- Favorites icon -->
                                  <a class="pointer z2 mr1 wishlist-icon" title="Fjern til ønskelisten" @click="addRemoveProdWishList(prod.ID, 'removed')" v-if="prodIdsWishList.includes(prod.ID)">
                                  <span class="mintgreen">
                                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24"><path d="M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"/></svg>
                                  </span>
                                  </a>
                                  <!-- Unfavorites icon -->
                                  <a class="pointer z2 mt1 mr1 wishlist-icon" title="Tilføj til ønskeliste"
                                    @click="addRemoveProdWishList(prod.ID, 'added')" v-else>
                                    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                      width="35.000000pt" height="35.000000pt" class="mintgreen h4" viewBox="0 0 2048.000000 2048.000000"
                                      preserveAspectRatio="xMidYMid meet">
                                      <g transform="translate(0.000000,2048.000000) scale(0.100000,-0.100000)"
                                      fill="#000000" stroke="none">
                                      <path d="M6660 16374 c-915 -84 -1727 -468 -2350 -1110 -442 -457 -757 -1019
                                      -913 -1629 -81 -315 -107 -515 -114 -866 -29 -1472 480 -2589 1852 -4059 214
                                      -229 759 -769 1040 -1030 841 -782 1943 -1725 3475 -2975 107 -87 284 -233
                                      393 -323 l197 -164 168 139 c92 77 343 283 557 458 1230 1006 2291 1907 2965
                                      2519 686 623 1294 1228 1705 1696 679 773 1106 1463 1341 2166 161 481 233
                                      994 221 1574 -6 275 -17 398 -58 615 -139 748 -504 1429 -1049 1958 -575 559
                                      -1278 898 -2100 1013 -179 25 -644 30 -855 10 -853 -82 -1550 -392 -2245
                                      -1000 -133 -116 -408 -392 -548 -548 -53 -60 -99 -108 -102 -108 -3 0 -49 48
                                      -102 108 -144 162 -417 434 -559 557 -330 288 -600 470 -952 640 -365 177
                                      -742 287 -1167 341 -120 15 -689 28 -800 18z m775 -842 c338 -53 598 -134 890
                                      -278 344 -169 642 -391 991 -739 225 -224 368 -382 684 -755 128 -151 236
                                      -275 240 -275 4 0 112 124 240 275 384 453 643 731 871 937 577 518 1166 788
                                      1861 854 169 15 587 7 728 -16 420 -66 805 -211 1146 -430 164 -106 288 -208
                                      460 -380 250 -250 386 -439 539 -750 157 -317 239 -596 279 -945 18 -156 21
                                      -513 6 -695 -134 -1558 -1086 -2807 -4085 -5356 -864 -735 -2030 -1693 -2051
                                      -1685 -23 9 -972 788 -1589 1305 -1876 1572 -2946 2604 -3595 3466 -588 782
                                      -871 1465 -940 2270 -15 178 -12 539 5 690 60 519 244 985 554 1403 115 155
                                      390 433 538 545 415 314 889 506 1412 573 164 20 648 12 816 -14z"/>
                                      </g>
                                    </svg>
                                  </a>
                                </div>
                                <a :href="'#/webshop/product?id=' + prod.ID" class="cart-icon" v-if="prod.CATEGORY_ID != 104">
                                  <div v-if="prod.get_product_image.length">
                                    <!-- Widget products -->
                                    <img :data-key="index"
                                      :src="typeof 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+haaId+'.jpg' !== 'undefined' && 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+haaId+'.jpg' !== null ? 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+haaId+'.jpg' : 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/productPng.php?id='+haaId"
                                      width="100%" class="prod-img" rel="preload" @load="onImageLoad(prod.ID)"
                                      @error="checkimage(prod.ID, prod.PRODUCT_GROUP, index)" v-if="prod.PRODUCT_GROUP == '1000' || prod.PRODUCT_GROUP == '1300' || prod.PRODUCT_GROUP == '1400' || prod.PRODUCT_GROUP == '2000' || prod.PRODUCT_GROUP == '2100' || prod.PRODUCT_GROUP == '2200' || prod.PRODUCT_GROUP == '2300' || prod.PRODUCT_GROUP == '2400' || prod.PRODUCT_GROUP == '2500' || prod.PRODUCT_GROUP === '10001' || prod.PRODUCT_GROUP === '10002' || prod.PRODUCT_GROUP == '10003' || prod.PRODUCT_GROUP == '10004' || prod.PRODUCT_GROUP == '10005' ">
                                    <!-- Regular products -->
                                    <img id="imagefcrm" :src="'https://newcrm.kundematch.dk'+prod.get_product_image[0].showURL"
                                      width="100%" rel="preload" class="prod-img" @load="onImageLoad(prod.ID)" v-else>
                                  </div>
                                  <div v-else>
                                    <!-- Widget prisen -->
                                    <img :src="prodImage.VALUE" width="100%" rel="preload" class="prod-img" @load="onImageLoad(prod.ID)" @error="checkimage(prod.ID, prod.PRODUCT_GROUP, index)" v-for="prodImage in prod.get_element_property" v-if="prodImage.IBLOCK_PROPERTY_ID == 429 && prod.PRODUCT_GROUP == '9001'">
                                  </div>
                                </a>
                              </div>
                              <div class="center">
                                <div class="pb2"></div>
                                <a :href="'#/webshop/product?id=' + prod.ID" class="cart-icon"><span
                                    class="h5 darkblue bold block">{{prod.NAME}}</span></a>
                                <span
                                  class="h6 mintgreen bold">{{prod.PRICE.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}}
                                  kr</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mt3"><span class="bold">{{prodMsg}}</span></div>
                    </div>
                  </div>
                </el-tab-pane>

                <el-tab-pane :name="cat.ID.toString()" :label="cat.VALUE + ' (' + (cat.PRODUCT_COUNT - deductBadgesProduct) + ')'"
                  v-for="(cat,index) in catData" :key="index">
                  <div class="fit">
                    <div class="right-align hide" v-if="prodMsg == ''">
                      <el-pagination small layout="prev, pager, next" :total="parseInt(lastPage)"
                        @current-change="paginationChanged" :current-page="parseInt(curPage)">
                      </el-pagination>
                    </div>
                    <div class="clearfix" v-if="insideLoading">
                      <div class="col-12">
                        <div class="loader"></div>
                        <p class="center mediumgrey bold">Genererer forhåndsvisning...</p>
                      </div>
                    </div>
                    <div class="flex flex-wrap" v-else>
                      <div :id="'prodId-'+prod.ID" class="lg-col-3 md-col-4 p0" v-for="(prod,index) in prodData" :key="index">
                        <div class="py2 px1">
                          <div :class="'clearfix py4 img-loader loader-'+prod.ID">
                            <div class="col-12">
                              <div class="loader"></div>
                            </div>
                          </div>
                          <div :class="'hide prodImg-'+prod.ID">
                            <div class="relative border muted-border more-muted-background">
                              <div class="absolute right-0 mt1">
                                <!-- Bladders download icon -->
                                <!-- <a class="pointer z2 mt1 download-icon" title="Hent" v-if="prod.PRODUCT_GROUP == '9001'" @click="downloadFiles('https://widget.haandvaerker.dk/prisen/winnersBadge/bladder/rendered/' + haaId + '/badges.zip')">
                                  <i class="el-icon-download darkblue h2"></i>
                                </a> -->
                                <!-- Favorites icon -->
                                <a class="pointer z2 mr1 wishlist-icon" title="Fjern til ønskelisten" @click="addRemoveProdWishList(prod.ID, 'removed')" v-if="prodIdsWishList.includes(prod.ID)">
                                  <span class="mintgreen">
                                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24"><path d="M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"/></svg>
                                  </span>
                                </a>
                                <!-- Unfavorites icon -->
                                <a class="pointer z2 mt1 mr1 wishlist-icon" title="Tilføj til ønskeliste"
                                  @click="addRemoveProdWishList(prod.ID, 'added')" v-else>
                                  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                      width="35.000000pt" height="35.000000pt" class="mintgreen h4" viewBox="0 0 2048.000000 2048.000000"
                                      preserveAspectRatio="xMidYMid meet">
                                      <g transform="translate(0.000000,2048.000000) scale(0.100000,-0.100000)"
                                      fill="#000000" stroke="none">
                                      <path d="M6660 16374 c-915 -84 -1727 -468 -2350 -1110 -442 -457 -757 -1019
                                      -913 -1629 -81 -315 -107 -515 -114 -866 -29 -1472 480 -2589 1852 -4059 214
                                      -229 759 -769 1040 -1030 841 -782 1943 -1725 3475 -2975 107 -87 284 -233
                                      393 -323 l197 -164 168 139 c92 77 343 283 557 458 1230 1006 2291 1907 2965
                                      2519 686 623 1294 1228 1705 1696 679 773 1106 1463 1341 2166 161 481 233
                                      994 221 1574 -6 275 -17 398 -58 615 -139 748 -504 1429 -1049 1958 -575 559
                                      -1278 898 -2100 1013 -179 25 -644 30 -855 10 -853 -82 -1550 -392 -2245
                                      -1000 -133 -116 -408 -392 -548 -548 -53 -60 -99 -108 -102 -108 -3 0 -49 48
                                      -102 108 -144 162 -417 434 -559 557 -330 288 -600 470 -952 640 -365 177
                                      -742 287 -1167 341 -120 15 -689 28 -800 18z m775 -842 c338 -53 598 -134 890
                                      -278 344 -169 642 -391 991 -739 225 -224 368 -382 684 -755 128 -151 236
                                      -275 240 -275 4 0 112 124 240 275 384 453 643 731 871 937 577 518 1166 788
                                      1861 854 169 15 587 7 728 -16 420 -66 805 -211 1146 -430 164 -106 288 -208
                                      460 -380 250 -250 386 -439 539 -750 157 -317 239 -596 279 -945 18 -156 21
                                      -513 6 -695 -134 -1558 -1086 -2807 -4085 -5356 -864 -735 -2030 -1693 -2051
                                      -1685 -23 9 -972 788 -1589 1305 -1876 1572 -2946 2604 -3595 3466 -588 782
                                      -871 1465 -940 2270 -15 178 -12 539 5 690 60 519 244 985 554 1403 115 155
                                      390 433 538 545 415 314 889 506 1412 573 164 20 648 12 816 -14z"/>
                                      </g>
                                    </svg>
                                </a>
                              </div>
                              <!-- Regular products -->
                              <a :href="'#/webshop/product?id=' + prod.ID" class="cart-icon" v-if="prod.CATEGORY_ID != 104">
                                <div v-if="prod.get_product_image.length ">
                                  <!-- Widget products -->
                                    <img :data-key="index"
                                      :src="typeof 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+haaId+'.jpg' !== 'undefined' && 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+haaId+'.jpg' !== null ? 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+haaId+'.jpg' : 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/productPng.php?id='+haaId"
                                      width="100%" class="prod-img" rel="preload" @load="onImageLoad(prod.ID)"
                                      @error="checkimage(prod.ID, prod.PRODUCT_GROUP, index)" v-if="prod.PRODUCT_GROUP == '1000' || prod.PRODUCT_GROUP == '1300' || prod.PRODUCT_GROUP == '1400' || prod.PRODUCT_GROUP == '2000' || prod.PRODUCT_GROUP == '2100' || prod.PRODUCT_GROUP == '2200' || prod.PRODUCT_GROUP == '2300' || prod.PRODUCT_GROUP == '2400' || prod.PRODUCT_GROUP == '2500' || prod.PRODUCT_GROUP === '10001' || prod.PRODUCT_GROUP === '10002' || prod.PRODUCT_GROUP == '10003' || prod.PRODUCT_GROUP == '10004' || prod.PRODUCT_GROUP == '10005'">
                                    <!-- Regular products -->
                                    <img id="imagefcrm" :src="'https://newcrm.kundematch.dk'+prod.get_product_image[0].showURL"
                                      width="100%" rel="preload" class="prod-img" @load="onImageLoad(prod.ID)" v-else>
                                </div>
                                <div v-else>
                                  <!-- Widget prisen -->
                                    <img :src="prodImage.VALUE" width="100%" rel="preload" class="prod-img" @load="onImageLoad(prod.ID)" @error="checkimage(prod.ID, prod.PRODUCT_GROUP, index)" v-for="prodImage in prod.get_element_property" v-if="prodImage.IBLOCK_PROPERTY_ID == 429 && prod.PRODUCT_GROUP == '9001'">
                                </div>
                              </a>
                            </div>
                            <div class="center">
                              <div class="pb2"></div>
                              <a :href="'#/webshop/product?id=' + prod.ID" class="cart-icon"><span
                                  class="h5 darkblue bold block">{{prod.NAME}}</span></a>
                              <span
                                class="h6 mintgreen bold">{{prod.PRICE.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}}
                                kr</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mt3"><span class="bold">{{prodMsg}}</span></div>
                    </div>
                  </div>
                </el-tab-pane>

              </el-tabs>
            </div>
          </div>
          <div class="pb3 lg-hide"></div>
        </div>
      </div>
      <WebshopFooter v-if="!insideLoading">
      </WebshopFooter>
    </div>
  </div>
</template>

<script>
import WebshopHeader from './header'
import WebshopFooter from './footer'
export default {
  name: '',
  components: {
    WebshopHeader,
    WebshopFooter
  },
  data () {
    return {
      loading: true,
      insideLoading: true,
      salesPerson: '',
      haaId: '',
      showbadge: '',
      showtaktext: false,
      activeTabName: '0',
      tabPosition: 'top',
      catData: '',
      totalProdCount: 0,
      totalprodpercat: 0,
      prodData: '',
      deductBadgesProduct: 0,
      search: '',
      prodIdsWishList: '',
      prodMsg: '',
      curPage: 1,
      lastPage: 20,
      heightimage: 380,
      widthimage: 380,
      form: {
      },
      badgesCount: 0,
      renderedStreamer: false,
      renderedBladder: false,
      loopStatusImageCheck: '',
      prodBadgesIdsArr: []
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.showbadge = localStorage.getItem('showbadgewebshop')
    this.currentTab()
    this.displayCategories()
    this.getProdIdWishList()
    this.displayProducts()
    this.removeUrlQstinMrk()
  },
  methods: {
    checkimage (prodId, prodGroup, index) {
      var imgLink = ''
      if (prodGroup !== '9001') {
        imgLink = 'http://widget.haandvaerker.dk/products/' + this.prodData[index].PRODUCT_GROUP + '/' + this.prodData[index].EXT + '/productPng.php?id=' + this.haaId
      } else {
        imgLink = 'http://widget.haandvaerker.dk/prisen/winnersBadge/streamer/streamerPng.php?id=' + this.haaId
      }
      var img = document.querySelectorAll('.prodImg-' + prodId + ' img')
      for (var i = 0; i < img.length; i++) {
        img[i].src = imgLink
      }
    },
    onImageLoad (prodId) {
      setTimeout(() => {
        var hidden = document.querySelectorAll('.prodImg-' + prodId)
        for (var i = 0; i < hidden.length; i++) {
          hidden[i].classList.remove('hide')
        }
        var loader = document.querySelectorAll('.loader-' + prodId)
        for (var x = 0; x < loader.length; x++) {
          loader[x].remove()
        }
      }, 500)
    },
    showBreadCrumb () {
      document.querySelector('.breadCrumb').classList.remove('hide')
    },
    removeUrlQstinMrk () {
      let url = window.location.href
      history.pushState({}, null, url.replace('/?', ''))
    },
    displayCategories () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
        // operation: 'bitrixApi',
        // salesPerson: this.salesPerson,
        // type: 'GET',
        // url: 'webshop/GetCategory/0'
      }
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/webshop/GetCategory/0', data, {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var dataRes = response.data.data
            var prodCount = 0
            var dataResres = []
            if (this.showbadge === 'no') {
              dataResres = dataRes.filter(function (a) {
                return a.ID !== 205
              })
            } else {
              dataResres = dataRes
            }
            this.catData = dataResres
            dataResres.forEach(element => {
              this.getproducteachcount(element)
            })
            this.totalProdCount = prodCount
          } else {
            console.log('Error in displayCategories()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    getproducteachcount (catResess) {
      // getting prod from this cat
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
        // operation: 'bitrixApi',
        // salesPerson: this.salesPerson,
        // type: 'GET',
        // url: 'webshop/GetProducts/0/0/' + catResess.ID
      }
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/webshop/GetProducts/0/0/' + catResess.ID, data, { headers }, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var dataRes = response.data.data
            var prodcountpercat = []
            var thisvar = this
            prodcountpercat = dataRes.filter(function (element) {
              if (element.CATEGORY_ID === 205) {
                for (var k = 0; k < element.get_element_property.length; k++) {
                  if (element.get_element_property[k].IBLOCK_PROPERTY_ID === 427 && element.get_element_property[k].VALUE === thisvar.haaId) {
                    return element
                  }
                }
              } else {
                return element.NEED_GRAPHIC_HELP === 'No' && element.DESCRIPTION !== 'Dette viser, at denne virksomhed har brug for hjælp til hans/hendes grafik til dette specifikke produkt'
              }
            })
            catResess['PRODUCT_COUNT'] = prodcountpercat.length
            this.totalProdCount += prodcountpercat.length
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
      // end of  getting prod from this cat   delete this if the product list is done
    },
    getProdIdWishList () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetWishList/' + this.haaId
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var dataRes = response.data.data.data
            var prodIds = []
            for (var i = 0; i < dataRes.length; i++) {
              var prodId = dataRes[i].ID
              if (prodId !== null) {
                prodIds.push(prodId)
              }
            }
            this.prodIdsWishList = prodIds
          } else {
            console.log('Error in getProdIdWishList()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    displayProducts () {
      this.insideLoading = true
      var data = {
        // operation: 'bitrixApi',
        salesPerson: this.salesPerson
        // type: 'GET',
        // url: 'webshop/GetProducts/0/0/' + this.activeTabName + '?page=' + this.curPage
      }
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/webshop/GetProducts/0/0/' + this.activeTabName + '?page=1', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var dataRes = response.data.data
            var pagLastPage = response.data.data.last_page + '0'
            var products = []
            var allproducts = []
            var deductBadgesCount = 0
            if (this.activeTabName === '205') {
              for (var j = 0; j < dataRes.length; j++) {
                for (var k = 0; k < dataRes[j].get_element_property.length; k++) {
                  if (dataRes[j].get_element_property[k].IBLOCK_PROPERTY_ID === 427) {
                    if (dataRes[j].get_element_property[k].VALUE === this.haaId) {
                      products.push(dataRes[j])
                    } else {
                      deductBadgesCount++
                    }
                  }
                }
              }
            } else {
              products = dataRes.filter(function (a) {
                return a.NEED_GRAPHIC_HELP === 'No'
              })
            }
            if (this.showbadge === 'no') {
              allproducts = products.filter(function (a) {
                return a.CATEGORY_ID !== 205
              })
            } else {
              allproducts = products
            }
            this.prodData = allproducts
            this.deductBadgesProduct = deductBadgesCount
            this.lastPage = pagLastPage
            if (!dataRes.length) {
              this.prodMsg = 'Ingen Produkter.'
            } else {
              this.prodMsg = ''
            }
            if (this.activeTabName === '205') {
              this.showBreadCrumb()
              this.getBadges()
              for (var i = 0; i < this.prodData.length; i++) {
              // Get product badges id
                for (var x = 0; x < this.prodData[i].get_element_property.length; x++) {
                  if (this.prodData[i].get_element_property[x].IBLOCK_PROPERTY_ID === 428) {
                    this.prodBadgesIdsArr.push(parseInt(this.prodData[i].get_element_property[x].VALUE))
                  }
                }
              }
            }
            for (var e = 0; e < this.prodData.length; e++) {
              if (this.prodData[e].SIZE === '') {
                this.prodData[e].EXT = '0'
              } else {
                this.prodData[e].EXT = this.prodData[e].SIZE.replace(/\s/g, '').replaceAll('B', '').replaceAll('H', '')
              }
              this.prodData[e].LOAD = true
              this.loading = false
              this.insideLoading = false
            }
          } else {
            this.showBreadCrumb()
            this.loading = false
            this.insideLoading = false
            console.log('Error in displayProducts()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    currentTab () {
      if (window.location.href.indexOf('?cat_id') > -1) {
        var urlStr = window.location.href
        var url = new URL(urlStr.replace('/#', ''))
        var searchParams = url.searchParams
        this.activeTabName = searchParams.get('cat_id')
      }
    },
    tabChanged () {
      const input = document.querySelector('input.search')
      input.value = ''
      this.curPage = 1
      this.displayProducts()
      this.insideLoading = true
    },
    displaySearchedProducts () {
      this.insideLoading = true
      this.removeUrlQstinMrk()
      var search = this.search
      var searchVal = ''
      if (search !== '') {
        searchVal = search
      } else {
        searchVal = 0
      }
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetProducts/0/' + searchVal + '/' + this.activeTabName + '?page=' + this.curPage
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var dataRes = response.data.data
            var pagLastPage = response.data.data.last_page + '0'
            this.prodData = dataRes
            this.lastPage = pagLastPage
            if (!dataRes.length) {
              this.prodMsg = 'Ingen Produkter Fundet.'
            } else {
              this.prodMsg = ''
            }
            for (var i = 0; i < this.prodData.length; i++) {
              if (this.prodData[i].SIZE === '') {
                this.prodData[i].EXT = '0'
              } else {
                this.prodData[i].EXT = this.prodData[i].SIZE.replace(/\s/g, '').replaceAll('B', '').replaceAll('H', '')
              }
              this.prodData[i].LOAD = true
              // Get product badges id
              for (var x = 0; x < this.prodData[i].get_element_property.length; x++) {
                if (this.prodData[i].get_element_property[x].IBLOCK_PROPERTY_ID === 428) {
                  this.prodBadgesIdsArr.push(parseInt(this.prodData[i].get_element_property[x].VALUE))
                }
              }
            }
            this.getBadges()
          } else {
            this.loading = false
            this.insideLoading = false
            console.log('Error in displaySearchedProducts()')
          }
        }
      )
    },
    addRemoveProdWishList (id, status) {
      const compId = this.haaId
      const prodId = id
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'POST',
        url: 'webshop/AddRemoveWishlist',
        parameters: JSON.stringify({
          CompanyID: compId,
          ProductID: prodId
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.getProdIdWishList()
            var search = this.search
            if (search !== '') {
              this.displaySearchedProducts()
            } else {
              this.displayProducts()
            }
            this.calulateWishListCount()
            if (status === 'added') {
              this.$toastr('success', 'Tilføjet')
            } else {
              this.$toastr('success', 'Fjernet')
            }
          } else {
            this.loading = false
            this.insideLoading = false
            console.log('Error in addRemoveProdWishList()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
      this.insideLoading = true
    },
    calulateWishListCount () {
      setTimeout(() => {
        const prodWishList = this.prodIdsWishList
        for (var i = 0; i < prodWishList.length; i++) {
        }
        document.querySelector('.totalWishList').innerText = i
      }, 1000)
    },
    paginationChanged (val) {
      var pagCurPage = (`${val}`)
      this.curPage = pagCurPage
      var search = this.search
      if (search !== '') {
        this.displaySearchedProducts()
      } else {
        this.displayProducts()
      }
      this.insideLoading = true
    },
    downloadFiles (url) {
      var filename = url.substring(url.lastIndexOf('/') + 1).split('?')[0]
      var xhr = new XMLHttpRequest()
      xhr.responseType = 'blob'
      xhr.onload = function () {
        var a = document.createElement('a')
        a.href = window.URL.createObjectURL(xhr.response)
        a.download = filename
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        a.remove()
      }
      xhr.open('GET', url)
      xhr.send()
    },
    pushtonewsfeed () {
      this.$router.push('/newsfeed')
    },
    getBadges () {
      /* eslint-disable no-unused-vars */
      var data = {
        operation: 'oversigt_getsupplierprofilebyid',
        levid: this.haaId,
        salesPerson: this.salesPerson
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          var badgesList = res.Badges
          var filteredBadges = badgesList.filter(function (property) {
            return property['Industry'] != null
          })
          var badgesArr = this.mergedBadges(filteredBadges)
          this.badgesCount = badgesArr.length
          for (var i = 0; i < badgesArr.length; i++) {
            if (!this.prodBadgesIdsArr.includes(badgesArr[i].id)) {
              this.addProduct(badgesArr[i].id, badgesArr[i].name, i, badgesArr.length)
            }
          }
          var thisVar = this
          this.loopStatusImageCheck = window.setInterval(function () {
            thisVar.getImageStatus('streamer', 'https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/rendered/' + thisVar.haaId + '/' + thisVar.badgesCount + '.jpg')
            thisVar.getImageStatus('bladder', 'https://widget.haandvaerker.dk/prisen/winnersBadge/bladder/rendered/' + thisVar.haaId + '/' + thisVar.badgesCount + '.jpg')
          }, 2000)
        },
        (err) => {
          console.log('Error in getBadgesCount()', err)
          this.show = false
        }
      )
    },
    mergedBadges (filteredBadges) {
      var badges = []
      var removeDuplicates = []
      var finalBadges = []
      for (var i = 0; i < filteredBadges.length; i++) {
        if (filteredBadges[i].Industry === 'TV inspektion') {
          filteredBadges[i].Industry = 'TVInspektion'
        }
        for (var x = 0; x < badges.length; x++) {
          if (filteredBadges[i].Industry + '' + filteredBadges[i].Area.replace('Region', '') + ' ' + filteredBadges[i].Position === badges[x].name) {
            removeDuplicates.push({
              id: badges[x].id,
              name: badges[x].name
            })
          }
        }
        badges.push({
          id: filteredBadges[i].Id,
          name: filteredBadges[i].Industry + '' + filteredBadges[i].Area.replace('Region', '') + ' ' + filteredBadges[i].Position
        })
      }
      // Remove duplicate badges
      for (var j = 0; j < badges.length; j++) {
        for (var k = 0; k < removeDuplicates.length; k++) {
          if (removeDuplicates[k].name === badges[j].name && removeDuplicates[k].id !== badges[j].id) {
          } else {
            finalBadges.push({
              id: badges[j].id,
              name: badges[j].name
            })
          }
        }
      }
      return finalBadges
    },
    addProduct (badgeId, badgeName, badgeIndex, badgeLength) {
      // var yearListArr = badgeYear.split(',')
      // var sortedYearArr = yearListArr.sort(function (a, b) {
      //   return a - b
      // })
      var id = badgeId
      // var years = ''
      var name = badgeName
      var index = badgeIndex + 1
      var search = this.search
      // if (sortedYearArr.length >= 4) {
      //   years = sortedYearArr[0] + '-' + sortedYearArr[sortedYearArr.length - 1].substring(2)
      // } else {
      //   for (var i = 0; i < sortedYearArr.length; i++) {
      //     if (i !== sortedYearArr.length - 1) {
      //       years += sortedYearArr[i] + ','
      //     } else {
      //       years += sortedYearArr[i]
      //     }
      //   }
      // }
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'POST',
        url: 'webshop/AddProduct',
        parameters: JSON.stringify({
          product_name: name,
          product_price: 200,
          supplier_id: this.haaId,
          badge_id: id,
          image_url: 'https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/rendered/' + this.haaId + '/' + index + '.jpg',
          category_id: 205,
          description: 'Skal du have mere opmærksomhed på vejene? Pynt bilen med flere streamers her'
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            if (index === badgeLength) {
              this.displayCategories()
              if (search !== '') {
                this.displaySearchedProducts()
              } else {
                this.displayProducts()
              }
            }
          } else {
            console.log('Error in addProduct()', response)
          }
        },
        (response) => {
          console.log('Error in addProduct()', response)
        }
      )
    },
    getImageStatus (badge, url) {
      var request = new XMLHttpRequest()
      var thisVar = this
      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          if (request.status === 200) {
            if (badge === 'bladder') {
              clearInterval(thisVar.loopStatusCheck)
              thisVar.displayAllBadges = true
            }
            clearInterval(thisVar.loopStatusImageCheck)
            thisVar.loading = false
            thisVar.insideLoading = false
          } else {
            if (badge === 'streamer') {
              thisVar.renderedStreamer = true
            } else {
              thisVar.renderedBladder = true
            }
          }
        }
      }
      request.open('GET', url, true)
      request.send()
    }
  },
  watch: {
    'search': function (newval, oldval) {
      setTimeout(() => {
        this.displaySearchedProducts()
      }, 200)
      this.insideLoading = true
    }
  }
}
</script>
<style>
  #productFilter .el-tabs--top .el-tabs__nav {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  #productFilter .el-tabs__item {
    display: block;
  }
  #productFilter .el-tabs__item.is-active {
    color: #003645;
    font-weight: bold;
    pointer-events: none;
  }
  #productFilter .el-tabs--top .el-tabs__item.is-top:hover {
    color: unset;
  }
  #productFilter .el-tabs--top .el-tabs__nav-wrap.is-top::after {
    display: none;
  }
  #productFilter .el-tabs__active-bar {
    display: none;
  }
  #productFilter .prod-img {
    /*height: 380px;*/
    height: auto;
    object-fit: cover;
  }
  @media (max-width: 64em) {
    #productFilter .el-tabs--top .el-tabs__nav {
      display: block;
    }
    #productFilter .el-tabs__item {
      padding: 0;
    }
    #productFilter .prod-img {
      height: auto;
      object-fit: contain;
    }
  }
  @media (max-width: 52em) {
    #productFilter .el-tabs--left .el-tabs__header.is-left {
      width: 100%;
      margin-right: 0;
      margin-bottom: 3rem;
    }
    .el-tabs__content {
      width: 100%;
    }
  }
  .img-loader {
    background: white;
    width:100%;
    height:100%;
  }
  .center-xy {
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  }
  .img-loader .loader::before, .img-loader .loader::after {
    background: white;
  }
  /* #productFilter div#tab-104 {
    display: none;
  }
  #productFilter div#prodId-6489 {
    display: none;
  } */
</style>


// WEBPACK FOOTER //
// products.vue?6d058df4